import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import SignaturePad from "react-signature-canvas";

export const DialogFormSignature = props => {
  const {collaborator, control, save} = props;

  const signaturePadRef = React.useRef(null);

  const open = Boolean(collaborator?.id);
  const signatureStyle = {
    width: "100%",
    height: 150,
    backgroundColor: "#d5d5d5",
    border: "2px solid #868686",
  };

  const [isEmpty, setIsEmpty] = useState(false);

  const handleSave = () => {
    if (signaturePadRef.current.isEmpty()) return setIsEmpty(true);

    const trimmed = signaturePadRef.current.getTrimmedCanvas();
    save(collaborator, trimmed.toDataURL("image/png"));
    control(null);
  };

  const clear = () => {
    signaturePadRef.current.clear();
  };

  return (
    <Modal
      show={open}
      onHide={() => control(null)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Firma aquí...</Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <SignaturePad
          ref={signaturePadRef}
          canvasProps={{style: signatureStyle}}
          onBegin={() => setIsEmpty(false)}
        />
        {isEmpty && (
          <small className="text-danger font-weight-bolder">
            La firma es requerida
          </small>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex">
        <button
          type="button"
          className="btn btn-secondary me-auto"
          onClick={() => clear()}
        >
          Borrar
        </button>

        <button
          type="button"
          className="btn btn-success"
          onClick={() => handleSave()}
        >
          Guardar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
